module.exports = __webpack_public_path__ + "img/gradient-4.88444fe8.png";